import { render } from "./ReferralCard.vue?vue&type=template&id=bdf285a4"
import script from "./ReferralCard.vue?vue&type=script&lang=js"
export * from "./ReferralCard.vue?vue&type=script&lang=js"

import "./ReferralCard.vue?vue&type=style&index=0&id=bdf285a4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__